import { createSlice } from "@reduxjs/toolkit";

export const addressSlice = createSlice({
    name: 'address',
    initialState: {
        value: '',
    },
    reducers: {
        setAddress: (state, {payload : address}) => {
           
            let testAddress = process.env.REACT_APP_TEST_ADDRESS;
            console.log('testAddress = ' + testAddress);
            if(testAddress){
                state.value = testAddress
            }else{
                state.value = address
            }
        },
        getAddress: (state, action) => {
            state.value = action.payload
        },
    },
});

export const { setAddress, getAddress } = addressSlice.actions;

export default addressSlice.reducer;